import { SampleMaturityResponse, SampleMaturityListResponse, CreateSampleMaturityRequest, UpdateSampleMaturityRequest } from "@/types/sampleMaturityTypes";
import { Client } from "./client";
import { FusaReply } from "@/types/replyTypes";

export class SampleMaturityFrontendController {
  client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }

  readAllByProjectId(projectId: string): Promise<SampleMaturityListResponse> {
    return this.client.read(`/api/sample-maturities/project/${projectId}`);
  }

  read(id: string): Promise<SampleMaturityResponse> {
    return this.client.read(`/api/sample-maturities/${id}`);
  }

  create(data: CreateSampleMaturityRequest): Promise<SampleMaturityResponse> {
    return this.client.create('/api/sample-maturities', data);
  }

  update(id: string, data: UpdateSampleMaturityRequest): Promise<SampleMaturityResponse> {
    return this.client.update(`/api/sample-maturities/${id}`, data);
  }

  delete(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/sample-maturities/${id}`);
  }
}
